import React from 'react';
import { Field } from 'react-final-form';
import { createUseStyles } from 'react-jss';
import Switch from '../Switch/Switch';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
import PropTypes from 'prop-types';

const SwitchContent = (props) => {
  const { t, name, } = props;
  const styles = useStyles();
  return (
    <div className={styles.rightColumn}>
      {t('no_word')}
      <Field
        name={name}
        component={(fieldProps) => (
          <Switch
            className={styles.switch}
            wrapperStyle={{ marginLeft: 15, marginRight: 15, transform: 'rotate(180deg)', }}
            isEnabled={Boolean(fieldProps.input.value)}
            onChange={(value) => fieldProps.input.onChange(value)}
          />
        )}
      />
      {t('yes_word')}
    </div>
  );
};


const useStyles = createUseStyles({
  rightColumn: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: 0,
    fontWeight: 600,
  },
  switch: {
    color: 'red',
  },
  '@media screen and (max-width: 991px)': {
    rightColumn: {
      width: 'auto',
      fontWeight: 'bold',
      color: '#54515A',
      marginTop: '0.5em',
    },
  },
});

SwitchContent.propTypes = {
  t: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
}

export default withScopedTranslations('ad_vehicle_description')(SwitchContent);
